import React, { useState, useEffect, useContext } from "react";
import {
  assignMemberEmail,
  fetchAdminTransactions,
  fetchMembers,
} from "../api/api";
import { UserContext } from "../context/UserContext";
import { useMsal } from "@azure/msal-react";
import HeaderQC from "./HeaderQC";

const QCTeamLeadDashboard = () => {
  const { user } = useContext(UserContext);
  const [transactions, setTransactions] = useState([]);
  const [teamMembers, setTeamMembers] = useState([]);
  const [selectedMembers, setSelectedMembers] = useState({});

  const fetchData = async () => {
    if (!user) return;
    try {
      const data = await fetchAdminTransactions(user);
      const dataMember = await fetchMembers(user);
      if (data && Array.isArray(data)) setTransactions(data);
      if (dataMember && Array.isArray(dataMember)) setTeamMembers(dataMember);
    } catch (err) {
      console.error("Fetch error", err);
    }
  };

  useEffect(() => {
    if (sessionStorage.getItem("refreshOnBack") === "true") {
      sessionStorage.removeItem("refreshOnBack");
      window.location.reload();
    }
    fetchData();
  }, [user]);

  const handleAssign = async (transaction_id, member) => {
    try {
      await assignMemberEmail(transaction_id, user, member);
      await fetchData(); // re-fetch updated data
    } catch (error) {
      console.error("Failed:", error);
    }
  };

  const sortedTransactions = [...transactions].sort((a, b) => {
    const priority = {
      Reverted: 0,
      Pending_Assignment: 1,
      default: 2,
    };

    const aPriority = priority[a.status] ?? priority.default;
    const bPriority = priority[b.status] ?? priority.default;

    return aPriority - bPriority;
  });

  const handleEdit = (id) => {
    window.location.href = `/edit-transaction/${id}`;
  };

  // setTransactions((prev) =>
  //   prev.map((t) =>
  //     t.transactionId === txn.transactionId
  //       ? { ...t, teamAAssignedId: txn.selectedMember }
  //       : t
  //   )
  // );

  const { instance } = useMsal();

  const handleLogout = () => {
    instance.logoutRedirect({
      postLogoutRedirectUri: "/login", // Redirect here after logout
    });
  };

  return (
    <div className="min-h-screen bg-light">
      <HeaderQC />
      <div className="container-fluid py-2 ">
        {/* Main Row Layout */}
        <div className="col">
          {/* Stats Column */}
          <div className="row-md-3 py-2">
            <div className="col d-flex align-items-center justify-content-between ">
              {/* Stats Cards - all with colored backgrounds */}
              <div className="d-flex gap-3 w-100">
                <div className="card flex-fill rounded-4 shadow-sm border-0 bg-primary text-white">
                  <div className="card-body">
                    <div className="d-flex justify-content-between align-items-center">
                      <div>
                        <p className="mb-0">Total Transactions</p>
                        <h3 className="fw-bold mb-0">{transactions.length}</h3>
                      </div>
                      <i className="bi bi-graph-up fs-1"></i>
                    </div>
                  </div>
                </div>

                <div className="card flex-fill rounded-4 shadow-sm border-0 bg-warning text-white">
                  <div className="card-body">
                    <div className="d-flex justify-content-between align-items-center">
                      <div>
                        <p className="mb-0">Pending Transactions</p>
                        <h3 className="fw-bold mb-0">
                          {
                            transactions.filter(
                              (txn) => txn.status === "Pending_Assignment"
                            ).length
                          }
                        </h3>
                      </div>
                      <i className="bi bi-clock-history fs-1"></i>
                    </div>
                  </div>
                </div>

                <div className="card flex-fill rounded-4 shadow-sm border-0 bg-success text-white">
                  <div className="card-body">
                    <div className="d-flex justify-content-between align-items-center">
                      <div>
                        <p className="mb-0">Assigned Transactions</p>
                        <h3 className="fw-bold mb-0">
                          {
                            transactions.filter(
                              (txn) => txn.status === "Pending_Check"
                            ).length
                          }
                        </h3>
                      </div>
                      <i className="bi bi-person-check fs-1"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Table Column */}
          <div className="card-body p-0 w-100">
            <div className="card-header bg-white border-0 py-3">
              <h5 className="card-title mb-0">Transaction List</h5>
            </div>
            <div className="card-body px-0">
              <div className="table-responsive">
                <table className="table table-hover align-middle w-100">
                  <thead className="table-light">
                    <tr>
                      <th>Transaction ID</th>
                      <th>Status</th>
                      <th>Assigned To</th>
                      <th>Actions</th>
                      <th>View</th>
                    </tr>
                  </thead>
                  <tbody>
                    {sortedTransactions.map((txn) => (
                      <tr key={txn.transactionId}>
                        <td>{txn.transactionId}</td>

                        <td>
                          <span
                            className={`badge rounded-pill bg-${
                              txn.status === "Pending_Check"
                                ? "success"
                                : txn.status === "Pending_Assignment"
                                ? "warning"
                                : txn.status === "Reverted"
                                ? "danger"
                                : "primary"
                            }`}
                          >
                            {txn.status}
                          </span>
                        </td>

                        <td>
                          <select
                            className="form-select form-select-sm rounded-pill"
                            defaultValue=""
                            disabled={
                              txn.status === "Complete" || txn.assigned_id
                            }
                            onChange={(e) =>
                              setSelectedMembers((prev) => ({
                                ...prev,
                                [txn.transactionId]: e.target.value,
                              }))
                            }
                          >
                            <option value="" disabled>
                              {txn.status === "Complete" || txn.assigned_id
                                ? txn.assigned_id
                                : "Assign Member"}
                            </option>
                            {txn.status !== "Complete" &&
                              !txn.assigned_id &&
                              teamMembers.map((member) => (
                                <option
                                  key={member.emailId}
                                  value={member.emailId}
                                >
                                  {member.name}
                                </option>
                              ))}
                          </select>
                        </td>
                        <td>
                          <button
                            className={`btn btn-sm ${
                              txn.status === "Complete"
                                ? "btn-success" // Green for approved
                                : txn.assigned_id || txn.status === "Reverted"
                                ? "btn-secondary" // Grey for already assigned
                                : "btn-primary" // Blue for assign
                            }`}
                            disabled={
                              txn.status === "Complete" ||
                              txn.assigned_id ||
                              txn.status === "Reverted"
                            }
                            onClick={() =>
                              handleAssign(
                                txn.transactionId,
                                selectedMembers[txn.transactionId]
                              )
                            }
                          >
                            {txn.status === "Complete"
                              ? "Transaction Approved"
                              : txn.assigned_id || txn.status === "Reverted"
                              ? "Assigned"
                              : "Assign"}
                          </button>
                        </td>
                        <td className="px-4">
                          <i
                            className="bi bi-eye text-black fs-5 cursor-pointer"
                            onClick={() => handleEdit(txn.transactionId)}
                            style={{
                              transition: "0.3s",
                              transform: "scale(1)",
                            }}
                            onMouseOver={(e) =>
                              (e.currentTarget.style.transform = "scale(1.1)")
                            }
                            onMouseOut={(e) =>
                              (e.currentTarget.style.transform = "scale(1)")
                            }
                          ></i>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QCTeamLeadDashboard;
